import CreateBillingClient from "./CreateBillingClient";
import DisplayBillingClient from "./DisplayBillingClient";
import { Route } from "react-router-dom";

const routes = {
  key: "BILLING_CLIENT",
  routes: ({ userScope }) => [
    <Route path={`${userScope}/billing-client`} key="billing-client">
      <Route path=":slug" element={<DisplayBillingClient />} />
      <Route
        path="creation"
        key={"billing-client-creation"}
        element={<CreateBillingClient />}
      />
    </Route>,
  ],
};
export default routes;
